<template>
  <span>
    <template v-if="production.artists">{{ production.artists }}, </template>
    <em v-if="production.subtitle">
      {{ production.title }}, {{ production.subtitle }}
    </em>
    <em v-else>{{ production.title }}</em>
  </span>
</template>

<script>
export default {
  name: 'ProductionImageCaption',
  props: {
    production: {
      type: Object,
      required: true
    }
  }
}
</script>
